<template>
	<section class="details">
		<div class="container">
			<div class="row">
				<div class="col-7">
					<h3 class="details__headline">{{$t('event.location')}}</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-7">
					<div class="details__location">
						<div class="details__adress">
							<img src="/static/img/mark.svg" alt="">
							<span v-if="!event.place">{{event.city.name}}, {{event.city.country.name}}</span>
							<span v-if="event.place" v-for="place in getAddress">{{place}}</span>
						</div>
						<div class="details__distance">
							<p v-if="event.distance">>>{{ distance }}<span>km</span></p>
							<p v-if="!event.distance">>>0<span>km</span></p>
						</div>
						<a :href="googleMapsLink" target="_blank" class="details__maps">
							<p><span>{{$t('event.maps')}}</span> GoogleMaps →</p>
						</a>
					</div>
				</div>
			</div>
			<div id="judges" class="row">
				<div class="col-sm-12 col-lg-7">
					<div class="details__column-wrapper">
						<h3 class="details__headline details__headline--judges">{{$t('event.judges')}}</h3>
						<div class="details__breed">
							<h3 class="details__headline details__headline--breed">{{$t('event.breed')}}</h3>
							<div class="filter__wrapper filter__wrapper--detail">
								<input class="filter filter--detail comment__input comment__input--breed"
									   :class="{open: 'open' === showList, close: 'open' !== showList}"
									   @click="updateShowList('open')"
									   :placeholder="$t('event.breed')"
									   v-model="searchByBreed"
								>
								<ul v-show="'open' === showList"
									class="filter__list filter__list--detail"
								>
									<li class="filter__list-item filter__list-item--detail" @click="removeBreed()">{{$t('event.removeBreed')}}</li>
									<li class="filter__list-item filter__list-item--detail"
										v-for="breed in breedsList"
										@click="selectBreed(breed)"
										:class="{'filter__list-item--active': searchByBreed === breed.name}"
									>
										{{breed.name}}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-for="(group, i) in groups" class="detials__group-wrapper">
				<div class="row">
					<div class="col-sm-12 col-lg-7">
						<h3 class="group__headline"> {{i}}</h3>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12 col-lg-7">
						<div v-for="(judge, i) in group" class="group__details">
							<div class="group__judges">
								<span>{{i}}</span>
							</div>
							<div class="group__breeds">
								<span v-for="dog in judge.breeds">{{dog}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios'
	import { mapActions, mapMutations } from 'vuex'

	export default {
		components: {
		},
		data () {
			return {
				show: false,
				emptyEvent: {
					city: {
						name: '',
						country: {
							name: ''
						}
					}
				},
				event: {
					city: {
						name: '',
						country: {
							name: ''
						}
					},
					place: {
						place_id: '',
						address: '',
						url: ''
					}
				},
				groups: {},
				showList: '',
				breeds: [],
				searchByBreed: '',
				activeBreed: ''
			}
		},
		methods: {
			...mapMutations(['setCities']),
			...mapActions(['fetchEvents']),
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			fetchEvent () {
				const qs = require('qs')
				const config = {
					params: {
						page: this.$route.query.page
					},
					paramsSerializer (params) {
						return qs.stringify(params, { indices: false })
					}
				}
				return axios.get('/api/events/', config, {
				})
					.then(response => {
						this.event = response.data.results.find(event => {
							return event.id === parseInt(this.$route.params.id)
						})
					})
					.catch(error => {
						console.error(error)
					})
			},
			fetchGroups () {
				axios.get(`/api/events/${ this.$route.params.id }/judges/`, {
				})
					.then(response => {
						this.groups = response.data
					})
					.catch(error => {
						console.error(error)
					})
			},
			selectBreed (breed) {
				this.searchByBreed = breed.name
				this.activeBreed = breed.id
				this.showList = ''
			},
			removeBreed () {
				this.searchByBreed = ''
				this.activeBreed = ''
			},
			fetchBreeds () {
				axios.get('/api/dogs/subgroup/autocomplete/', {
				})
					.then(response => {
						this.breeds = response.data
					})
					.catch(error => {
						console.error(error)
					})
			}
		},
		computed: {
			breedsList () {
				const inputTest = breed => {
					const regExp = new RegExp('^' + this.searchByBreed, 'i')
					return regExp.test(breed.name)
				}
				return this.breeds.filter(inputTest)
			},
			activeGroup () {
				if (this.activeBreed) {
					return this.groups.filter(group => group.groups.some(item => item.id === this.activeBreed))
				} else {
					return this.groups
				}
			},
			distance () {
				return Math.round(this.event.distance)
			},
			getAddress () {
				return this.event && this.event.place && this.event.place.address.split(', ')
			},
			googleMapsLink () {
				return `https://www.google.pl/maps?q=${ this.event.city.name }`
			}
		},
		created () {
			this.fetchGroups()
			// this.fetchEvent(this.$route.query.page)
			this.fetchEvent()
			if (!this.$store.state.events.point) {
				navigator.geolocation.getCurrentPosition(({ coords }) => {
					this.setCities({ point: `${ coords.latitude },${ coords.longitude }` })
					this.fetchEvent()
				})
			}

			this.fetchBreeds()
			window.addEventListener('click', this.closeFlitersLists)
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";
	@import "../../styles/filters.scss";

	.details {
		padding: 25px 0;
		background-color: $gray-light;
		&__headline {
			text-align: left;
			font-family: $lato-bold;
			font-size: 16px;
			text-transform: uppercase;
			margin: 0;
			margin-bottom: 25px;
			&--judges {
				width: 41%;
				margin: 0;
			}
			&--breed {
				margin: 0;
			}
		}
		&__location {
			display: flex;
			margin-bottom: 30px;
		}
		&__adress {
			width: 41%;
			padding: 25px 55px 25px 50px;
			position: relative;
			background-color: $silver;
			img {
				position: absolute;
				top: 25px;
				left: 25px;
			}
			span {
				display: block;
				text-align: left;
				font-size: 14px;
				line-height: 20px;
			}
		}
		&__distance {
			width: 25%;
			background-color: $black;
			display: flex;
			align-items: center;
			justify-content: center;
			p {
				font-family: $lato-bold;
				font-size: 16px;
				line-height: 31px;
				letter-spacing: 0.05em;
				color: #fff;
				span {
					font-family: $lato;
					font-style: italic;
					font-size: 14px;
				}
			}
		}
		&__maps {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 34%;
			background-color: $silver;
			font-size: 14px;
			text-decoration: none;
			color: $black;
			span {
				font-family: $lato-bold;
			}
		}
		&__column-wrapper {
			display: flex;
			align-items: center;
			margin-bottom: 20px;
		}
		&__breed {
			width: 59%;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}

	.group {
		&__details {
			display: flex;
			justify-content: space-between;
			font-family: $lato-bold;
			font-size: 14px;
			line-height: 19px;
			margin-bottom: 25px;
		}
		&__headline {
			text-align: left;
			font-family: $lato-bold;
			font-size: 16px;
			margin: 0;
			margin-bottom: 25px;
		}
		&__judges {
			display: flex;
			flex-flow: column;
			align-items: flex-start;
			justify-content: center;
			width: 240px;
			min-height: 85px;
			background-color: $silver;
			padding-left: 20px;
		}
		&__breeds {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-wrap: wrap;
			width: 375px;
			min-height: 85px;
			background-color: $silver;
			padding: 20px;
			span {
				display: block;
				margin-right: 5px;
				text-align: left;
			}
		}
	}

	@media (max-width: 991.98px) {
		.details {
			&__location {
				width: 100%;
				flex-flow: column;
			}
			&__adress {
				width: 100%;
			}
			&__distance {
				width: 100%;
			}
			&__maps {
				padding: 20px 0;
				width: 100%;
			}
			&__breed {
				display: none;
			}
		}

		.group {
			&__details {
				flex-flow: column;
			}
			&__judges {
				width: 100%;
			}
			&__breeds {
				width: 100%;
				background-color: #ebedef;
			}
		}
	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
		.details {
			&__headline {
				&--judges {
					width: auto;
				}
			}
			&__location {
				width: 100%;
				flex-flow: column;
			}
			&__adress {
				width: 100%;
			}
			&__distance {
				width: 100%;
			}
			&__maps {
				padding: 20px 0;
				width: 100%;
			}
			&__breed {
				width: auto;
			}
			&__column-wrapper {
				justify-content: space-between;
			}
		}

		.group {
			&__details {
			}
			&__breeds {
				background-color: #ebedef;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Event/DetailsComponent.vue